import { DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Input, Modal } from 'antd';
import PropTypes from 'prop-types';
import React, { forwardRef, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Previewer } from '../components/design';
import { getPreview } from '../library/constants';
import styles from './addFile.module.scss';
import { showAlert } from '../components/message/alert.jsx';
const { TextArea } = Input


const DEFAULT_ACCEPT = {
    'image/jpg': ['.jpg'],
    'image/jpeg': ['.jpeg'],
    'image/png': ['.png'],
    'application/pdf': ['.pdf'],
    'image/tiff': ['.tiff', '.tif'],
    'image/svg+xml': ['.svg'],
    'image/vnd.adobe.photoshop': ['.psd'],
    'application/postscript': ['.eps'],
    'application/eps': ['.eps'],
    'application/x-eps': ['.eps'],
    'image/eps': ['.eps'],
    'image/x-eps': ['.eps'],
}

const AddFileUpload = forwardRef(function AddFileUpload({ acceptedFileTypes } = {}, ref) {
    const [, setFiles] = useState([])
    const [reload, setReload] = useState()
    const [isModalOpen, setisOpen] = useState(false)
    useEffect(() => {
        if (!ref.current) {
            ref.current = []
        }
        // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
        return () => ref.current.forEach(file => URL.revokeObjectURL(file.file.preview));
    }, [reload]);
    const accept = acceptedFileTypes?.length
        ? Object.fromEntries(Object.entries(DEFAULT_ACCEPT).filter(([, exts]) => exts.some(ext => acceptedFileTypes.includes(ext))))
        : DEFAULT_ACCEPT
    const { getRootProps, getInputProps } = useDropzone({
        multiple: true,
        maxSize: 10 * 1024 * 1024,
        maxFiles: 10,
        accept,
        onDropRejected: rejections => {
            showAlert(rejections.map(({ errors }) => errors.map(({ message }) => message)).join("\n"))
        },
        onDrop: acceptedFiles => {
            acceptedFiles.forEach(file => {
                addFile(file);
            });
        }
    })
    const addFile = (file) => {
        setFiles(files => {
            return [...files, Object.assign(file, {
                preview: URL.createObjectURL(file)
            })]
        })
        ref.current.push({ file, comment: null })
    }
    const updateComment = (index, comment) => {
        // ref.commentData.push(cmnt)
        if (!ref.current?.[index]) {
            ref.current[index] = {}
        }
        ref.current[index].comment = comment
    }
    const handleDeleteFile = (index) => {
        ref.current.splice(index, 1)
        setReload(!reload)
    }
    // const handleViewFile = () => {
    //     setisOpen(true)
    // }
    const handleViewFile = (file) => {
        const fileType = file.type;
        console.log(fileType);
        var blob = new Blob([file], { type: fileType });
        var blobURL = window.URL.createObjectURL(blob);
        window.open(blobURL);
    }

    return (
        <>

            <div className={styles.files}>
                {ref.current.length > 0 && (
                    ref.current.map(({ file, comment }, index) => {

                        return (
                            <div className={styles.file} key={file.name}>
                                <div className={styles.preview}>
                                    <img
                                        src={getPreview(file)}
                                        // Revoke data uri after image is loaded
                                        onLoad={() => { URL.revokeObjectURL(file.preview) }}
                                    />
                                </div>

                                <div className={styles.fileName}>
                                    <p className="label">{file.name}</p>
                                </div>

                                <div className={styles.comment}>
                                    <TextArea onBlur={(e) => {
                                        updateComment(index, e.target.value)
                                    }} defaultValue={comment} name={index} label="Add a comment" placeholder="type your message here.." />
                                </div>
                                <div className={styles.actions}>
                                    <Button onClick={() => { handleDeleteFile(index) }} icon={<DeleteOutlined />} >Delete</Button>
                                    <Button onClick={() => { handleViewFile(file) }} icon={<EyeOutlined />}>View</Button>
                                </div>
                                <Modal onCancel={() => { setisOpen(false) }} open={isModalOpen} footer={<Button onClick={() => { setisOpen(false) }} >Close</Button>}>
                                    <Previewer blob={file} />
                                </Modal>
                            </div>)
                    }
                    )
                )}
            </div>
            <input type="file" {...getInputProps()} style={{ display: "none" }} />
            <div {...getRootProps({ className: styles.dropArea })}>
                <div className={styles.dropIcon}>
                    +
                </div>
                <div className={`button--primary ${styles.uploadButton ?? ''}`}>Add File</div>
            </div>
        </>
    )
})

AddFileUpload.propTypes = {
    inputName: PropTypes.string,
    acceptedFileTypes: PropTypes.arrayOf(PropTypes.string),
}

export { AddFileUpload };
